import React, { useState } from "react";
import { useHotels } from "../../../../hooks/useHotels";
import useCommonActions from "../../../../hooks/useCommonActions";
import CommonPaymentPagePaymentOptions from "../../../../components/common/CommonPaymentPagePaymentOptions";
import { URLdecode } from "../../../../utils/url";
import { configurations } from "../../../../configurations";
import { useSelector } from "react-redux";
import { enqueueSnackbar } from "notistack";
import payForTicket from "../../../../controllers/Flight/payForTicket";
import { Modal } from "@mui/material";
import { Modal3 } from "../../../../components/DIsplay/Modal/Modal3";
import PinForm from "../../../../components/Settings/PinForm";
import odiopayRepayments from "../../../../controllers/Flight/odiopay";
import moment from "moment";

function FlightPaymentOptions({
  booking,
  callback,
  handleReturn,
  deductCommission,
  onPayLater,
}) {
  const params = URLdecode();
  const { initializePayment } = useHotels();
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const {
    userData: { user },
  } = useSelector((state) => state.user);
  const [openPin, setOpenPin] = useState(false);
  const [paymentUrl, setPaymentUrl] = useState();

  // console.log({ booking });

  const payWithOdiopay = async (data) => {
    setLoading(true);
    await odiopayRepayments(data)
      .then((res) => {
        if (!res?.cancelled) setLoading(false);
        callback?.("repayment");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  async function handlePay(data, pin) {
    const url = new URL(window.location.href);
    if (data?.method === configurations.payment.methods.odiopay.code) {
      return payWithOdiopay(data?.payload);
    }

    if (user?.advancedSecurityEnabled)
      if (data?.method === "Wallet" && !pin) return setOpenPin(true);

    const searchParams = url.searchParams;
    searchParams.set("payed", "true");
    url.search = searchParams.toString();
    const newUrl = url.toString();

    let obj = {
      flightBookingId: booking?.booking?.flightBooking?.at(0)?._id,
      paymentMode: data?.method, //method,
      callback: newUrl,
      onClose: callback && callback,
      deductCommission,
      saveCard: undefined,
      pin,
    };
    if (data?.method === "SavedCard") obj.savedCardId = data?.savedCard;

    setLoading(true);
    const res = await payForTicket(obj);
    setLoading(false);
    if (handleReturn) return handleReturn(res);
    if (res.return) {
      const url = res?.data?.data?.authorization_url;
      // setPaymentUrl(res?.data?.data?.authorization_url);
      // const width = 600; // Desired width of the popup window
      // const height = 400; // Desired height of the popup window

      // const left = window.screen.width / 2 - width / 2;
      // const top = window.screen.height / 2 - height / 2;

      // const options = `width=${width}, height=${height}, left=${left}, top=${top}`;

      if (url) {
        setPaymentUrl(url);
        const popup = window.open(url, "popupWindow");
        const checkPopupClosed = setInterval(() => {
          if (popup?.closed) {
            clearInterval(checkPopupClosed);
            setPaymentUrl(undefined);
            callback && callback();
          }
        }, 1000);
      } else {
        enqueueSnackbar(res?.msg, { variant: "success" });
        callback && callback();
      }
    } else enqueueSnackbar(res?.msg, { variant: "error" });
  }

  const isFlightViableForRepayment = () => {
    const flightBooking = booking?.booking?.flightBooking?.at(0);
    const refund = Boolean(
      flightBooking?.miniRules?.find(
        (rule) => rule?.category === "REFUND" && !rule?.notApplicable
      )
    );
    if (booking?.booking?.flightBooking?.at(0)?.isRefundable && refund) {
      const destinationDates = booking?.booking?.flightBooking
        ?.at(0)
        ?.destinations?.map((date) => date?.departureDate)
        ?.filter((date) => Boolean(date));
      const allDatesMoreThanAWeek = destinationDates?.every((date) =>
        moment(date).isAfter(moment().add(7, "days"))
      );
      return allDatesMoreThanAWeek;
    }
    return false;
  };

  return (
    <div className="w-full">
      <CommonPaymentPagePaymentOptions
        loading={loading}
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        onWalletConfirm={async () => {
          setModalOpen(false);
          await initializePayment({
            setLoading,
            paymentType: "Wallet",
            id: params?.id,
          });
        }}
        handlePay={(data) => handlePay(data)}
        service={
          isFlightViableForRepayment()
            ? configurations.products.flight.value
            : undefined
        }
        booking={booking}
        onHold={onPayLater}
      />
      <Modal
        open={Boolean(paymentUrl)}
        onClose={() => setPaymentUrl(undefined)}
      >
        <div className="h-full max-w-[100%] flex flex-col text-secondary bg-primary/80 items-center justify-center overflow-y-scroll md:overflow-y-hidden">
          {/* <iframe src={paymentUrl} title="Payment" className="w-full h-full" /> */}
          <div className="text-center">
            <div className="text-2xl">Waiting for payment</div>
            <p className="text-secondary">
              Close the payment window to continue
            </p>
          </div>
        </div>
      </Modal>
      <Modal3 title={"PIN"} open={openPin} setOpen={() => setOpenPin(false)}>
        <PinForm
          callback={(pin) => {
            setOpenPin(false);
            handlePay(
              { method: configurations.payment.methods.wallet.code },
              pin
            );
          }}
          close={() => setOpenPin(false)}
        />
      </Modal3>
    </div>
  );
}

export default FlightPaymentOptions;
